import { createAction } from '@reduxjs/toolkit';

export const SET_POST_TYPE_FILTER = 'SET_POST_TYPE_FILTER';
export const setPostTypeFilter = createAction<string>(SET_POST_TYPE_FILTER);

export const SET_CATEGORY_FILTER = 'SET_CATEGORY_FILTER';
export const setCategoryFilter = createAction<string>(SET_CATEGORY_FILTER);
